/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/recipient';

/**
 * editRecipient
 * url - /checkout/{apiversion}/cart/{cartId}/recipient?brand={brandId}
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {boolean} args.useAddressForAll
 * @param {object} args.recipient
 */
const editRecipient = ({
    env, jwtToken,
    cartId,
    cartItemId,
    useAddressForAll,
    recipient,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload = {
        cartItemId,
        useAddressForAll,
        recipient,
    };

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.putRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default editRecipient;
